/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metric_Market_Cap_To_Fdv_Name_LongInputs */



/**
* | output |
* | --- |
* | "Market Cap to FDV ratio" |
*
* @param {Metric_Market_Cap_To_Fdv_Name_LongInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const metric_market_cap_to_fdv_name_long = /** @type {((inputs?: Metric_Market_Cap_To_Fdv_Name_LongInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metric_Market_Cap_To_Fdv_Name_LongInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Market Cap to FDV ratio")
});